import { TrailerHandlingListURIParams } from '../../../models/allocation-register-uli-details/trailer-handling/register-uli-trailer-handling.model';

export class TrailerHandlingListLoad {
  public static readonly type = '[TrailerHandlingList] Load';

  constructor(public payload: TrailerHandlingListURIParams) {}
}

export class TrailerHandlingListInitialState {
  public static readonly type = '[TrailerHandlingList] Set initial state';
}
